import { useState } from 'react';
import type { Persoon } from '@fleet/shared';
import { Button, Input } from '../../design-system';
import { Modal } from '../../components/ui/Modal';
import { ApiError } from '../../lib/apiClient';
import { useUpdatePersoon } from './personen.api';

/** Popup: edit a person's basic details. */
export function EditPersoonModal({ persoon, onClose }: { persoon: Persoon; onClose: () => void }) {
  const update = useUpdatePersoon(persoon.id);
  const [naam, setNaam] = useState(persoon.naam);
  const [email, setEmail] = useState(persoon.email ?? '');
  const [error, setError] = useState('');

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!naam.trim()) return;
    setError('');
    try {
      await update.mutateAsync({ naam: naam.trim(), email: email.trim() || null });
      onClose();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Opslaan mislukt');
    }
  }

  return (
    <Modal open onClose={onClose} title="Persoon bewerken">
      <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        <Input
          label="Naam"
          value={naam}
          onChange={(e) => setNaam(e.target.value)}
          autoFocus
          required
        />
        <Input
          label="E-mail (optioneel)"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="naam@veerenstael.nl"
        />
        {error && <div style={{ fontSize: 13, color: '#B0543B', fontWeight: 700 }}>{error}</div>}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button variant="ghost" type="button" onClick={onClose}>
            Annuleren
          </Button>
          <Button variant="primary" type="submit" disabled={update.isPending}>
            Opslaan
          </Button>
        </div>
      </form>
    </Modal>
  );
}
